import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {
  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {

  }

  ngOnInit(): void {

    this.oidcSecurityService.isAuthenticated().subscribe((res: any) => {
      
      if(res || res == true) {
        this.router.navigate(['/doctor-panel/dashboard']);
      } else {
        this.oidcSecurityService.authorize(undefined, {
          customParams: {
            requestCulture: 'fa-IR'
          }
        });
      }
    })
  }

}
